"use client"

import { Dropdown, Button } from "react-bootstrap"
import { useLanguage } from "../hooks/use-translation"
import { Globe } from "lucide-react"

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage()

  return (
    <Dropdown align="end">
      <Dropdown.Toggle as="div" className="cursor-pointer">
        <Button variant="light" className="border-0 p-1">
          <Globe className="size-5" />
          <span className="visually-hidden">Switch language</span>
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => setLanguage("en")} active={language === "en"}>
          English
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setLanguage("el")} active={language === "el"}>
          Ελληνικά
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
